import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Route, RouteProps } from 'react-router-dom';

export const RouteWithTitle: React.FC<RouteProps & { title: string }> = ({ title, ...props }) => (
  <>
    <Helmet>
      <title>{`Clutter | ${title}`}</title>
    </Helmet>
    <Route {...props} />
  </>
);
